<template>
  <div>
    <Header :title="student[0].F0" :title_2="student[0].F1" :title_ne="$store.state.lang.neptun_kod"
      :title_na="$store.state.lang.nev" />
    <v-card elevation="1" class="mx-auto header-row mb-5 pa-0">
      <v-row class="ma-0 pa-0 pt-4">
        <v-col :cols="12" :lg="8" :md="8" :sm="12" class="d-flex align-center"><v-autocomplete label="Mintatanterv"
            :items="studentModuls" item-text="Mintatanterv_nev" item-value="Mintatanterv_kod" return-object
            @change="changeMintatanterv" v-model="selectedMintatanterv" color="white" class="white--text mx-3 pa-0"
            item-color="uni_blue2" :flat="true" hide-details dark>
          </v-autocomplete></v-col>
        <v-col :cols="12" :lg="4" :md="4" :sm="12">
          <LangSelector />
          <v-btn elevation="0" color="white" class="ma-1 float-right" href="https://ttr.sze.hu/Shibboleth.sso/Logout">
            <v-icon left>mdi-login</v-icon>
            {{ $store.state.lang.kijelentkezes }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mx-auto mt-5 main-card">
      <v-row class="mx-auto text-center header-font ma-0 pa-0 pt-5 pb-5" justify="center">
        <v-col :cols="12" :lg="2" :md="2" :sm="12"
          class="mx-2 border d-flex align-center justify-center matrix-first-buttons subtitle-1"
          @click="colorChange(0)">
          {{ $store.state.lang.alapallapot }}
        </v-col>
        <v-col :cols="12" :lg="2" :md="2" :sm="12"
          class="mx-2 border d-flex align-center justify-center matrix-first-buttons">{{ $store.state.lang.tajekoztato_1
          }}</v-col>
        <v-col :cols="12" :lg="2" :md="2" :sm="12"
          class="mx-2 border d-flex align-center justify-center matrix-first-buttons subtitle-1"
          @click="colorChange(1)">
          {{ $store.state.lang.felveheto_tantargyak }}
        </v-col>
        <v-col :cols="12" :lg="2" :md="2" :sm="12"
          class="mx-2 border d-flex align-center justify-center matrix-first-buttons">{{ $store.state.lang.tajekoztato_2
          }}</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mx-6 text-body-2 text-center">
        <p class="ma-0 pa-0">
          <b>{{ $store.state.lang.tajekoztato_cim1 }}</b>
          {{ $store.state.lang.tajekoztato_szoveg1 }}
        </p>
        <p class="ma-0 pa-0">
          <b>{{ $store.state.lang.tajekoztato_cim2 }}</b>
          {{ $store.state.lang.tajekoztato_szoveg2 }}
        </p>
        <p class="ma-0 pa-0">
          <b>{{ $store.state.lang.tajekoztato_cim3 }}</b>
          {{ $store.state.lang.tajekoztato_szoveg3 }}
        </p>
      </v-row>
      <v-divider class="mx-4"></v-divider>
      <v-row class="ma-0 pa-0 mb-4">
        <v-col :cols="12" :lg="4" :md="12" :sm="12" class="pa-0 ma-0 text-center">{{ $store.state.lang.szak }}:
          <b v-if="langName == 'hu'">{{ information.F3 }}</b><b v-else>{{ information.F16 }}</b></v-col>
        <v-col :cols="12" :lg="4" :md="12" :sm="12" class="pa-0 ma-0 text-center">{{ $store.state.lang.szakirany }}:
          <b>{{ information.F7 }}</b></v-col>
        <v-col :cols="12" :lg="4" :md="12" :sm="12" class="pa-0 ma-0 text-center">{{ $store.state.lang.tanterv }}: <b>{{
          information.F10 }}</b></v-col>
      </v-row>
      <div class="nezetrow d-flex justify-center pb-0">
        <label class="switch">
          <input type="checkbox" class="checkbox" v-model="nezet" @change="changeNezet" />
          <div class="slider" :style="{ '--my-label': `${sliderLabel}` }"></div>
        </label>
      </div>
      <div class="text-center">
        <p v-html="$store.state.lang.nezet_1" class="text-caption"></p>
      </div>
      <Chart :types="allSubjects" v-if="student && canShowChart" />
      <Jelmagyarazat :felevek="felevek" />
      <v-simple-table class="ma-0 pa-0 mx-3 pb-3" v-if="felevek.length > 0">
        <thead>
          <tr>
            <th v-for="(ind, index) in felevek.length + 1" :key="index" class="border text-center ma-0 pa-0">
              <div v-if="index == 0">
                <sub>{{ $store.state.lang.kredit }} </sub>/<sup>
                  {{ $store.state.lang.szak_keresese_ev }}</sup>
              </div>
              <div v-else :style="`padding: 1vh; background-color: ${bgColors([
                felevek[ind - 2].creditPerFelev -
                felevek[ind - 2].nullCreditSub,
                felevCredits[ind - 2],
              ])[0]
                }; color:${bgColors([
                  felevek[ind - 2].creditPerFelev -
                  felevek[ind - 2].nullCreditSub,
                  felevCredits[ind - 2],
                ])[1]
                }`">
                <div class="text-center">
                  {{ ind - 1 }}
                </div>
                <div>
                  {{
                    felevek[ind - 2].creditPerFelev -
                    felevek[ind - 2].nullCreditSub
                  }}
                  / {{ felevCredits[ind - 2] }}
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr v-for="credit in maxRow" :key="credit">
            <td class="border">{{ credit }}</td>
            <template v-for="felev in felevek">
              <template v-for="f in felev.subs">
                <td class="border" :key="f.Targykod" v-if="f.eddigi_kredit + 1 == credit"
                  :rowspan="f.Targy_kredit != 0 ? f.Targy_kredit : 1"
                  :style="`background-color: ${f.color}; color: ${f.text_color};`" @click="selectSubject(f)"
                  @drop="onDrop($event, felev.sem)" @dragover.prevent @dragenter.prevent draggable="true"
                  @dragstart="startDrag($event, f)">
                  <v-tooltip bottom color="uni_blue" close-delay="500" open-delay="500"
                    :style="`color: ${f.text_color}`">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <a href="javascript:void(0)" :style="`color: ${f.text_color}`"
                          @click.stop="tematikaMegtekintes(f.Targykod)" v-if="isRealSubject(f.Targynev)">{{
                            f.Targynev }}<br />{{ f.Targykod }}</a>
                        <input type="checkbox" :id="f.Targykod" class="text-warning mx-2 pt-2"
                          v-if="isRealSubject(f.Targynev)" @click.stop="countCredits(f, -1)"
                          :checked="f.done || manualDoneCodes.includes(f.Targykod)" :disabled="f.done" />
                      </div>
                    </template>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.table_megnevezes }}:
                      <span>{{ f.Targynev }}</span>
                    </p>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.table_beszamolas_fajtaja }}:
                      <span>Vizsga</span>
                    </p>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.table_kreditpont }}:
                      <span>{{ f.Targy_kredit }}</span>
                    </p>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.table_ajanlott_felev }}:
                      <span>{{ f.Felev_szam }}</span>
                    </p>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.teljesitve }}:
                      <span>{{
                        f.mikor == "soha" ? $store.state.lang.soha : f.mikor
                      }}</span>
                    </p>
                    <p class="ma-0 pa-0">
                      {{ $store.state.lang.table_elotanulmanyi_kov }}:
                      <span>{{ f.Elokovetelmeny_leiras_1 }}</span><br /><span>{{ f.Elokovetelmeny_leiras_2 }}</span>
                    </p>
                  </v-tooltip>
                </td>
              </template>
            </template>
          </tr>
          <tr class="border">
            <td v-for="(fel, ind) in felevek.length + 1" :key="ind" class="border pa-0 ma-0">
              <div v-if="ind == 0">
                {{ $store.state.lang.kredit }}
              </div>
              <div v-else :style="`padding: 1vh; background-color: ${bgColors([
                felevek[fel - 2].creditPerFelev -
                felevek[fel - 2].nullCreditSub,
                felevCredits[fel - 2],
              ])[0]
                }; color:${bgColors([
                  felevek[fel - 2].creditPerFelev -
                  felevek[fel - 2].nullCreditSub,
                  felevCredits[fel - 2],
                ])[1]
                }`">
                <div class="text-center">
                  {{ fel - 1 }}
                </div>
              </div>
            </td>
          </tr>
          <tr class="border">
            <td class="text-center" :colspan="felevek.length + 1"
              :style="`font-size: 20px !important; background-color: ${footerColor[0]}; color: ${footerColor[1]}`">
              {{ $store.state.lang.kotelelezo_tantargyak_ossz_kredit }}
              <b>{{ allCredit - allNullCreditSub }}</b> /
              <b>{{ getAllCredit }}</b>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-card class="mx-auto ma-0 pa-0 my-3 main-card">
      <p class="display-1 text-center font-weight-bold pa-0 py-3" v-if="felevek.length > 0">
        {{ $store.state.lang.tantargycsoportok }}
      </p>
      <v-row class="mx-auto ma-0 pa-0">
        <v-col :cols="12" :lg="6" :md="12" v-for="(types_obj, index) in types" :key="index" class="pa-0 ma-0">
          <v-card v-if="!types_obj.name.includes('Kötelező tárgyak')" class="pa-0 mx-3 my-2" elevation="1">
            <v-row class="pa-0 ma-0 font-weight-bold">
              <v-col :cols="12" :lg="6" :md="6" :sm="6">{{ types_obj.name }}</v-col>
              <v-col :cols="12" :lg="6" :md="6" :sm="6" v-if="types_obj.credit != null">{{
                $store.state.lang.teljesitendo_kredit
              }}:
                {{ types_obj.credit }}</v-col>
              <v-col :cols="12" :lg="6" :md="6" :sm="6" v-else-if="types_obj.tantargyak_szama != null">{{
                $store.state.lang.elvegzett_tantargy_csoport }}
                {{ types_obj.tantargyak_szama }}</v-col>
            </v-row>
            <p class="pa-0 ma-0 px-2 py-2 caption">
              {{ types_obj.leiras }}
            </p>
            <v-simple-table class="pa-1" v-if="types_obj.children.length == 0">
              <thead class="border-top rounded">
                <tr class="rounded">
                  <th
                    v-for="header in [$store.state.lang.table_sorszam, $store.state.lang.table_megnevezes, $store.state.lang.table_kod, $store.state.lang.teljesitve]"
                    :key="header"
                    :style="`background-color: ${bgColors([types_obj.credit || types_obj.tantargyak_szama, types_obj.credit ? getSecondAllCredit[index].credit : getSecondAllCredit[index].db])[0]}; color: ${bgColors([types_obj.credit || types_obj.tantargyak_szama, types_obj.credit ? getSecondAllCredit[index].credit : getSecondAllCredit[index].db])[1]}`">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sub, id) in types_obj.subjects" :key="id">
                  <td>{{ id + 1 }}</td>
                  <v-tooltip bottom color="uni_blue">
                    <template v-slot:activator="{ on, attrs }">
                      <td class="border" v-bind="attrs" v-on="on" @click="selectSubject(sub)"
                        :style="`background-color: ${sub.color}; color: ${sub.text_color};`">
                        <a href="javascript:void(0)" @click.stop="tematikaMegtekintes(sub.Targykod)"
                          :style="`color: ${sub.text_color};`">{{ sub.Targynev }}</a>
                      </td>
                    </template>
                    <p class="ma-0 pa-0">{{ $store.state.lang.table_megnevezes }}: <span>{{ sub.Targynev }}</span></p>
                    <p class="ma-0 pa-0">{{ $store.state.lang.table_kreditpont }}: <span>{{ sub.Targy_kredit }}</span>
                    </p>
                  </v-tooltip>
                  <td class="border">{{ sub.Targykod }}</td>
                  <td class="align-content-center text-center">
                    <input class="my-1 mx-auto" type="checkbox" :id="sub.Targykod"
                      @click.stop="countCredits(sub, index)"
                      :checked="sub.done || manualDoneCodes.includes(sub.Targykod)" :disabled="sub.done" />
                  </td>
                </tr>
                <tr>
                  <td class="text-center rounded" :colspan="4" v-if="types_obj.credit != null"
                    :style="`padding: 1vh; background-color: ${bgColors([types_obj.credit, getSecondAllCredit[index].credit])[0]}; color: ${bgColors([types_obj.credit, getSecondAllCredit[index].credit])[1]}`">
                    {{ $store.state.lang.kotelelezo_tantargyak_ossz_kredit }} <b>{{ types_obj.credit }}</b> / <b>{{
                      getSecondAllCredit[index].credit }}</b>
                  </td>
                  <td class="text-center rounded" :colspan="4" v-else-if="types_obj.tantargyak_szama != null"
                    :style="`padding: 1vh; background-color: ${bgColors([types_obj.tantargyak_szama, getSecondAllCredit[index].db])[0]}; color: ${bgColors([types_obj.tantargyak_szama, getSecondAllCredit[index].db])[1]}`">
                    {{ $store.state.lang.elvegzett_tantargy_csoport }} <b>{{ types_obj.tantargyak_szama }}</b> / <b>{{
                      getSecondAllCredit[index].db }}</b>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <div v-else>
              <div v-for="(child, childKey) in types_obj.children" :key="childKey">
                <p class="mx-2 mt-3 font-weight-bold"><b>{{ child.name }}</b></p>
                <v-simple-table class="mx-2">
                  <thead class="border-top rounded">
                    <tr>
                      <th
                        v-for="header in [$store.state.lang.table_sorszam, $store.state.lang.table_megnevezes, $store.state.lang.table_kod, $store.state.lang.teljesitve]"
                        :key="header"
                        :style="`background-color: ${bgColors([types_obj.credit || types_obj.tantargyak_szama, types_obj.credit ? getSecondAllCredit[index].credit : getSecondAllCredit[index].db])[0]}; color: ${bgColors([types_obj.credit || types_obj.tantargyak_szama, types_obj.credit ? getSecondAllCredit[index].credit : getSecondAllCredit[index].db])[1]}`">
                        {{ header }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sub, id) in child.subjects" :key="id">
                      <td>{{ id + 1 }}</td>
                      <td class="border" @click="selectSubject(sub)"
                        :style="`background-color: ${sub.color}; color: ${sub.text_color};`">
                        <a href="javascript:void(0)" @click.stop="tematikaMegtekintes(sub.Targykod)"
                          :style="`color: ${sub.text_color};`">{{ sub.Targynev }}</a>
                      </td>
                      <td>{{ sub.Targykod }}</td>
                      <td class="text-center">
                        <input type="checkbox" :checked="sub.done || manualDoneCodes.includes(sub.Targykod)"
                          @click.stop="countCredits(sub, index)" :disabled="sub.done" />
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <div class="text-center rounded mx-3 mb-2" v-if="types_obj.credit != null"
                :style="`padding: 1vh; background-color: ${bgColors([types_obj.credit, getSecondAllCredit[index].credit])[0]}; color: ${bgColors([types_obj.credit, getSecondAllCredit[index].credit])[1]}`">
                {{ $store.state.lang.kotelelezo_tantargyak_ossz_kredit }} <b>{{ types_obj.credit }}</b> / <b>{{
                  getSecondAllCredit[index].credit }}</b>
              </div>
              <div class="text-center rounded mx-3 mb-2" v-else-if="types_obj.tantargyak_szama != null"
                :style="`padding: 1vh; background-color: ${bgColors([types_obj.tantargyak_szama, getSecondAllCredit[index].db])[0]}; color: ${bgColors([types_obj.tantargyak_szama, getSecondAllCredit[index].db])[1]}`">
                {{ $store.state.lang.elvegzett_tantargy_csoport }} <b>{{ types_obj.tantargyak_szama }}</b> / <b>{{
                  getSecondAllCredit[index].db }}</b>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog" width="1000px">
      <v-card class="pa-0 ma-0">
        <v-card-title class="pa-3 d-flex justify-end sticky">
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <TantargyTematika v-if="subject" :subject="subject" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LangSelector from "@/components/LangSelector.vue";
import Header from "@/components/Header.vue";
import TantargyTematika from "@/components/TantargyTematika.vue";
import Jelmagyarazat from "@/components/Jelmagyarazat.vue";
import Chart from "@/components/Chart.vue";

export default {
  components: { LangSelector, TantargyTematika, Header, Jelmagyarazat, Chart },
  data: () => ({
    dialog: false, subjects: [], subject: null, felevek: [], allSubjects: [], maxRow: 0,
    felevCredits: [], information: {}, allCredit: 0, getAllCredit: 0, felevekAlap: [], maxRowAlap: 0,
    utokovetelmenyColors: ["#3c0000", "#a20000", "#ff0909", "#ff6f6f", "#EC407A", "#f38caf", "#f8bbd0", "#fce8ef"],
    elokovetelmenyColors: ["#061d30", "#135a91", "#1a78c2", "#1d87da", "#63b5f6", "#90caf9", "#bcdffb", "#e8f4fd"],
    freeSubsCount: 0, types: [], getSecondAllCredit: [], allNullCreditSub: 0,
    student: [{ F0: "", F1: "" }], studentModuls: [],
    selectedMintatanterv: { Modulkod: "", Mintatanterv_kod: "", Mintatanterv_nev: "" },
    nezet: false, canShowChart: false, manualDoneCodes: []
  }),
  computed: {
    langName() { return this.$route.params.lang; },
    bgColors() { return (n) => [n[0] <= n[1] && n[0] != null && n[0] > 0 ? "#43A047" : "white", n[0] <= n[1] && n[0] != null && n[0] > 0 ? "white" : "black"]; },
    footerColor() { return this.allCredit == this.getAllCredit ? ["#43A047", "white"] : ["white", "black"]; },
    sliderLabel() { return `'${this.$store.state.lang.nezet} ${this.nezet ? '2' : '1'}'`; }
  },
  async mounted() { this.getDatas(); },
  methods: {
    isRealSubject(name) { return isNaN(name); },
    countCredits(f, index) {
      const kr = parseInt(f.Targy_kredit) || 0;
      if (!this.manualDoneCodes.includes(f.Targykod)) {
        this.manualDoneCodes.push(f.Targykod);
        this.getAllCredit += kr;
        if (index == -1) this.felevCredits[f.Felev_szam - 1] += kr;
        else { this.getSecondAllCredit[index].credit += kr; this.getSecondAllCredit[index].db++; }
      } else {
        this.manualDoneCodes = this.manualDoneCodes.filter(c => c !== f.Targykod);
        this.getAllCredit -= kr;
        if (index == -1) this.felevCredits[f.Felev_szam - 1] -= kr;
        else { this.getSecondAllCredit[index].credit -= kr; this.getSecondAllCredit[index].db--; }
      }
      this.$forceUpdate();
    },
    async getDatas(datas) {
      this.$store.commit("setOverlay", true);
      try {
        // Reset
        this.felevek = [];
        this.felevekAlap = [];
        this.canShowChart = false;
        this.information = {};
        this.student = [{ F0: "", F1: "" }];
        this.subjects = [];
        this.allSubjects = [];
        this.studentModuls = [];
        this.selectedMintatanterv = { Modulkod: "", Mintatanterv_kod: "", Mintatanterv_nev: "" };
        this.types = [];
        this.allCredit = 0;
        this.felevCredits = [];
        this.allNullCreditSub = 0;
        this.getAllCredit = 0;
        this.getSecondAllCredit = [];
        this.maxRow = 0;
        this.maxRowAlap = 0;
        this.freeSubsCount = 0;

        var post = datas || { mintaterv: { Modulkod: this.$route.params.modul_kod, Mintatanterv_kod: this.$route.params.minta_kod, nezet: this.nezet } };
        const response = await this.$http.post("userMatrix/", post, { timeout: 0 });
        if (!response) {
          this.$router.push({ name: "Home", params: { lang: this.$route.params.lang } });
          return false;
        }
        this.canShowChart = response.canShowChart; this.information = response.information[0];
        this.felevek = response.felevek; this.student = response.student;
        this.felevek.forEach(item => item.subs.forEach(e => {
          if (!e.done) { e.color = e.archive == "igaz" ? "#cfd8dc" : "white"; e.text_color = "#038cac"; }
        }));
        this.felevekAlap = this.felevek; this.subjects = response.types[0]; this.allSubjects = response.types; this.studentModuls = response.student_moduls;
        this.selectedMintatanterv = this.studentModuls.find(m => m.Mintatanterv_nev == this.information.F10);
        this.types = [];
        response.types.forEach((element, index) => {
          if (index > 0) {
            element.subjects.forEach(s => { if (!s.done) { s.color = s.archive == "igaz" ? "#cfd8dc" : "white"; s.text_color = "#038cac"; } });
            this.types.push(element);
          }
        });
        let countAll = 0;
        this.felevek.forEach((f, i) => {
          this.allCredit += f.creditPerFelev; let cr = 0;
          f.subs.forEach(s => { if (s.done) { cr += parseInt(s.Targy_kredit); countAll += parseInt(s.Targy_kredit); } });
          this.felevCredits[i] = cr; if (f.nullCreditSub) this.allNullCreditSub += f.nullCreditSub;
        });
        this.getAllCredit = countAll;
        this.getSecondAllCredit = this.types.map(t => {
          let c = { credit: 0, db: 0 };
          t.subjects.forEach(s => { if (s.done) { c.credit += parseInt(s.Targy_kredit); c.db++; } });
          return c;
        });
        this.maxRow = Math.max(...this.felevek.map(o => o.creditPerFelev));
        this.maxRowAlap = this.maxRow;
      } catch (e) { console.error(e); } finally { this.$store.commit("setOverlay", false); }
    },
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move"; evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", item.Targykod);
      evt.dataTransfer.setData("item", JSON.stringify(item));
    },
    onDrop(evt, list) {
      const itemID = evt.dataTransfer.getData("itemID");
      const firstItem = JSON.parse(evt.dataTransfer.getData("item"));
      if (!this.isRealSubject(firstItem.Targynev)) return;
      if (!firstItem.done) {
        var tantargyak = this.subjects.subjects;
        this.felevek[parseInt(firstItem.Felev_szam) - 1].subs.forEach((element) => {
          if (this.isRealSubject(element.Targykod)) {
            if ((element.done || this.manualDoneCodes.includes(element.Targykod)) && firstItem.Felev_szam != list) {
              this.countCredits(element, -1);
            }
          }
        });
        var t = [firstItem], szamlalo = 0, van = true, osszes = [];
        while (van) {
          szamlalo++;
          var ret = this.utoKovetelmenyek(t, tantargyak, szamlalo);
          van = ret.van; t = ret.utokov;
          ret.utokov.forEach((element) => osszes.push(element));
        }
        this.felevek.forEach((item) => item.subs.forEach((element) => {
          if (!element.done && !this.manualDoneCodes.includes(element.Targykod)) {
            element.color = element.archive == "igaz" ? "#cfd8dc" : "white"; element.text_color = "#038cac";
          } else if (element.done) {
            if (this.isRealSubject(element.Targykod)) { element.color = "#18960c"; element.text_color = "white"; }
          }
        }));
        osszes.forEach((item) => this.felevek.forEach((element) => element.subs.forEach((value) => {
          if (firstItem.Targykod == value.Targykod) { value.color = "#FB8C00"; value.text_color = "white"; }
        })));
        this.csere(itemID, list, osszes);
      }
    },
    csere(code, felev_szam, utokovetelmenyek) {
      var eredeti = this.subjects.subjects;
      var tantargy = {};
      eredeti.forEach((item) => { if (item.Targykod == code && item.Felev_szam != felev_szam) { item.Felev_szam = felev_szam; tantargy = item; } });
      var felevekk = [], felevekSeged = [];
      utokovetelmenyek.forEach((element) => eredeti.forEach((item) => {
        if (element.Targykod == item.Targykod && parseInt(element.Felev_szam) - parseInt(tantargy.Felev_szam) < parseInt(element.hanyadik)) {
          item.Felev_szam = (parseInt(tantargy.Felev_szam) + parseInt(element.hanyadik)).toString();
        }
      }));
      eredeti.forEach((item) => { if (!felevekSeged.includes(parseInt(item.Felev_szam))) { felevekSeged.push(parseInt(item.Felev_szam)); } });
      this.subjects.subjects = eredeti;
      felevekSeged.sort((a, b) => a - b);
      if (this.felevek.length > felevekSeged.length) { felevekSeged = []; this.felevek.forEach((element) => felevekSeged.push(element.sem)); }
      felevekSeged.forEach((item) => {
        var felev = { sem: item.toString(), creditPerFelev: 0, subs: [], nullCreditSub: 0 };
        var allCredits = 0, nullSub = 0;
        eredeti.forEach((element) => {
          if (element.Felev_szam == item.toString()) {
            element.eddigi_kredit = allCredits;
            if (parseInt(element.Targy_kredit) == 0) { allCredits += 1; nullSub += 1; }
            else { allCredits += parseInt(element.Targy_kredit); }
            felev.subs.push(element);
          }
        });
        felev.nullCreditSub = nullSub; felev.creditPerFelev = allCredits; felevekk.push(felev);
      });
      var maxRoww = parseInt(Math.max.apply(Math, felevekk.map((o) => o.creditPerFelev)));
      felevekk.forEach((item) => {
        item.subs.push({ Targykod: item.sem, Targynev: Math.floor(Math.random() * 1000), Felev_szam: item.sem, Targy_kredit: maxRoww - item.creditPerFelev, eddigi_kredit: item.creditPerFelev });
      });
      this.felevek = felevekk; this.maxRow = maxRoww;
    },
    colorChange(type) {
      this.felevek.forEach(item => item.subs.forEach(e => {
        if (!(e.done || this.manualDoneCodes.includes(e.Targykod))) { e.color = e.archive == "igaz" ? "#cfd8dc" : "white"; e.text_color = "#038cac"; }
      }));
      if (type == 1) {
        this.felevek.forEach(item => item.subs.forEach(e => {
          if (!(e.done || this.manualDoneCodes.includes(e.Targykod)) && e.archive != "igaz") {
            const nincsElokov = !e.Elokovetelmeny_leiras_1 && !e.Elokovetelmeny_leiras_2 && this.isRealSubject(e.Targynev);
            const elokovKesz = e.elokov?.length > 0 && e.elokov.every(kod => this.felevek.some(f => f.subs.some(s => s.Targykod === kod && (s.done || this.manualDoneCodes.includes(s.Targykod)))));
            if (nincsElokov || elokovKesz) { e.color = "#81C784"; e.text_color = "white"; }
          }
        }));
      } else if (type == 0) {
        this.felevek = [...this.felevekAlap]; this.maxRow = this.maxRowAlap;
        this.felevek.forEach(item => item.subs.forEach(e => {
          if (!(e.done || this.manualDoneCodes.includes(e.Targykod))) { e.color = e.archive == "igaz" ? "#cfd8dc" : "white"; e.text_color = "#038cac"; }
        }));
      }
    },
    selectSubject(tantargy) {
      this.felevek.forEach(item => item.subs.forEach(e => {
        if (!(e.done || this.manualDoneCodes.includes(e.Targykod))) { e.color = e.archive == "igaz" ? "#cfd8dc" : "white"; e.text_color = "#038cac"; }
        else { e.color = "#18960c"; e.text_color = "white"; }
      }));
      this.types.forEach(t => t.subjects.forEach(e => {
        if (!(e.done || this.manualDoneCodes.includes(e.Targykod))) { e.color = e.archive == "igaz" ? "#cfd8dc" : "white"; e.text_color = "#038cac"; }
        else { e.color = "#18960c"; e.text_color = "white"; }
      }));
      if (this.isRealSubject(tantargy.Targynev)) { tantargy.color = "#FB8C00"; tantargy.text_color = "white"; }
      const tantargyak = this.allSubjects.flatMap(i => i.subjects);
      let tU = [tantargy], szU = 0, vanU = true, osszU = [];
      while (vanU) {
        szU++; let retU = this.utoKovetelmenyek(tU, tantargyak, szU);
        vanU = retU.van; tU = retU.utokov; retU.utokov.forEach(e => osszU.push(e));
      }
      osszU.forEach(item => {
        this.felevek.forEach(f => f.subs.forEach(v => { if (item.Targykod == v.Targykod) { v.color = this.utokovetelmenyColors[item.hanyadik - 1] || "#FB8C00"; v.text_color = "white"; } }));
        this.types.forEach(t => t.subjects.forEach(v => { if (item.Targykod == v.Targykod) { v.color = this.utokovetelmenyColors[item.hanyadik - 1] || "#FB8C00"; v.text_color = "white"; } }));
      });
      if (tantargy.elokov?.length > 0) {
        let tE = [tantargy], szE = 0, vanE = true, osszE = [];
        while (vanE) {
          szE++; let retE = this.elokovetelmenyekFunction(tE, tantargyak, szE);
          vanE = retE.talalat; tE = retE.elokov; retE.elokov.forEach(e => osszE.push(e));
        }
        osszE.forEach(item => {
          this.felevek.forEach(f => f.subs.forEach(v => { if (item.Targykod == v.Targykod) { v.color = this.elokovetelmenyColors[item.hanyadik - 1] || "#061d30"; v.text_color = "white"; } }));
          this.types.forEach(t => t.subjects.forEach(v => { if (item.Targykod == v.Targykod) { v.color = this.elokovetelmenyColors[item.hanyadik - 1] || "#061d30"; v.text_color = "white"; } }));
        });
      }
      this.$forceUpdate();
    },
    elokovetelmenyekFunction(t, tantargyak, szamlalo) {
      let ret = { elokov: [], talalat: false };
      t.forEach(e => {
        e.elokov?.forEach(kod => {
          tantargyak.forEach(v => { if (v.Targykod == kod) { v.hanyadik = szamlalo; ret.talalat = true; ret.elokov.push(v); } });
        });
      });
      return ret;
    },
    utoKovetelmenyek(t, tantargyak, szamlalo) {
      let ret = { van: false, utokov: [] };
      t.forEach(e => tantargyak.forEach(item => {
        if (item.elokov?.includes(e.Targykod)) { ret.van = true; ret.utokov.push(item); item.hanyadik = szamlalo; }
      }));
      return ret;
    },
    async tematikaMegtekintes(kod) {
      const res = await this.$http.get("getSubjectDetails/" + kod);
      this.subject = res.details; this.dialog = true;
    },
    changeNezet() { this.changeMintatanterv(this.nezet); },
    changeMintatanterv(n) {
      this.getDatas(
        {
          mintaterv: { Modulkod: this.selectedMintatanterv.Modulkod, Mintatanterv_kod: this.selectedMintatanterv.Mintatanterv_kod, nezet: n }
        });
    }
  }
};
</script>

<style scoped>
td {
  font-size: 12px !important;
  height: 20px !important;
  min-width: 150px !important;
  border: 1px solid #e0e0e0 !important;
}

.header-font {
  font-size: 12px;
}

.checkbox {
  display: none;
}

.slider {
  width: 8rem;
  height: 2rem;
  background-color: lightgray;
  border-radius: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  transition: 0.3s;
  box-shadow: 0 0 10px 0 rgb(0, 0, 0, 0.25) inset;
  cursor: pointer;
}

.slider::before {
  content: var(--my-label);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
  background-color: #fff;
  border-radius: 100px;
  transition: 0.3s;
  box-shadow: 0 0 10px 3px rgb(0, 0, 0, 0.25);
}

input:checked~.slider::before {
  transform: translateX(30px);
  box-shadow: 0 0 10px 3px rgb(0, 0, 0, 0.25);
  content: var(--my-label);
}

input:checked~.slider {
  background-color: #00adcb;
}

.header-row {
  background: linear-gradient(135deg, #00adcb 20%, #0c3c60);
}

/* A fejléc első cellájának bal felső sarka */
.v-simple-table thead tr th:first-child {
  border-top-left-radius: 10px !important;
}

/* A fejléc utolsó cellájának jobb felső sarka */
.v-simple-table thead tr th:last-child {
  border-top-right-radius: 10px !important;
}

/* Szükséges, hogy a táblázat ne vágja le a keretet */
.v-simple-table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
</style>